import React from 'react'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import StyleSheet from 'styles'
import ResultsMixin from './ResultsMixin'

const ResultsWidgetMixin = superclass => class extends ResultsMixin(superclass){

  dependsOn = () => {
    return this.loadData()
  }

  dependenciesMet = () => {
    return !!this.data.results && !this.data.loading
  }

  componentDidUpdate(prevProps, prevState) {
    if ((prevState.currentPage !== this.state.currentPage)
      // || (prevProps.widgetFilter !== this.props.widgetFilter)
      ) {
      this.loadData()
    }
  }

  get orderParams() {
    if (this.props.orderBy)
      return {
        [this.props.orderBy]: (this.props.orderDir || 'asc')
      }
    return undefined
  }

  get filter(){
    return this.props.widgetFilter
  }

  get resultsNameSpace() {
    return this.props.name
  }

  get title() {
    return this.props.title
  }

  Card = props => {
    if (this.props.content)
      return <div {...props}/>
    else
      return <Card className={styles.card} variant={this.props.raised ? 'raised' : 'flat'} {...props}/>
  }

  CardContent = props =>
    <CardContent className={styles.content} {...props} />
}

const styles = StyleSheet({
  card: {
    width: '100%',
    height: '100%',
    position: 'relative',
    boxSizing: 'border-box'
  },
  content: {
    justifyContent: 'left',
    alignItems: 'left',
    display: 'flex',
    flexDirection: 'column'
  },
})
export default ResultsWidgetMixin